import Instance from "../../../Axios";

const GetPlusEscaloes = () => async (dispatch) => {
  await Instance()
    .get(`/plus/adesoes/data/escaloes`)
    .then(({ data }) => {
      dispatch({ type: "GET_PLUS_ESCALOES", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetPlusEscaloes;
